/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Clientbanner_Cta1Inputs */

const id_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh untuk Windows & macOS`)
};

const ms_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun untuk Windows & macOS`)
};

const da_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download til Windows & macOS`)
};

const de_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Windows & macOS herunterladen`)
};

const en_us2_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows & macOS`)
};

const es_es2_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar para Windows y macOS`)
};

const es_mx2_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar para Windows y macOS`)
};

const fil_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-download para sa Windows at macOS`)
};

const fr_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger pour Windows et macOS`)
};

const it_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica per Windows e macOS`)
};

const hu_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltés Windows és macOS rendszerre`)
};

const nl_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download voor Windows & macOS`)
};

const no_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned for Windows og macOS`)
};

const pl_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz dla Windows i macOS`)
};

const pt_br2_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows & macOS`)
};

const pt_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar para Windows e macOS`)
};

const ro_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă pentru Windows și macOS`)
};

const fi_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa Windowsille ja macOS:lle`)
};

const sv_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner för Windows och macOS`)
};

const vi_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống cho Windows & macOS`)
};

const tr_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows ve macOS için İndir`)
};

const cs_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout pro Windows a macOS`)
};

const bg_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтеглете за Windows и macOS`)
};

const ru_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать для Windows и macOS`)
};

const uk_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити для Windows та macOS`)
};

const ar_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل لنظامي Windows و macOS`)
};

const hi_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड करें`)
};

const th_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดสำหรับ Windows และ macOS`)
};

const ja_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows & macOS 向けダウンロード`)
};

const zh_cn2_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows & macOS`)
};

const zh_hant1_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows & macOS`)
};

const ko_components_clientbanner_cta1 = /** @type {(inputs: Components_Clientbanner_Cta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows & macOS`)
};

/**
* | output |
* | --- |
* | "Download for Windows & macOS" |
*
* @param {Components_Clientbanner_Cta1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_clientbanner_cta1 = /** @type {((inputs?: Components_Clientbanner_Cta1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Clientbanner_Cta1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_clientbanner_cta1(inputs)
	if (locale === "ms") return ms_components_clientbanner_cta1(inputs)
	if (locale === "da") return da_components_clientbanner_cta1(inputs)
	if (locale === "de") return de_components_clientbanner_cta1(inputs)
	if (locale === "en-US") return en_us2_components_clientbanner_cta1(inputs)
	if (locale === "es-ES") return es_es2_components_clientbanner_cta1(inputs)
	if (locale === "es-MX") return es_mx2_components_clientbanner_cta1(inputs)
	if (locale === "fil") return fil_components_clientbanner_cta1(inputs)
	if (locale === "fr") return fr_components_clientbanner_cta1(inputs)
	if (locale === "it") return it_components_clientbanner_cta1(inputs)
	if (locale === "hu") return hu_components_clientbanner_cta1(inputs)
	if (locale === "nl") return nl_components_clientbanner_cta1(inputs)
	if (locale === "no") return no_components_clientbanner_cta1(inputs)
	if (locale === "pl") return pl_components_clientbanner_cta1(inputs)
	if (locale === "pt-BR") return pt_br2_components_clientbanner_cta1(inputs)
	if (locale === "pt") return pt_components_clientbanner_cta1(inputs)
	if (locale === "ro") return ro_components_clientbanner_cta1(inputs)
	if (locale === "fi") return fi_components_clientbanner_cta1(inputs)
	if (locale === "sv") return sv_components_clientbanner_cta1(inputs)
	if (locale === "vi") return vi_components_clientbanner_cta1(inputs)
	if (locale === "tr") return tr_components_clientbanner_cta1(inputs)
	if (locale === "cs") return cs_components_clientbanner_cta1(inputs)
	if (locale === "bg") return bg_components_clientbanner_cta1(inputs)
	if (locale === "ru") return ru_components_clientbanner_cta1(inputs)
	if (locale === "uk") return uk_components_clientbanner_cta1(inputs)
	if (locale === "ar") return ar_components_clientbanner_cta1(inputs)
	if (locale === "hi") return hi_components_clientbanner_cta1(inputs)
	if (locale === "th") return th_components_clientbanner_cta1(inputs)
	if (locale === "ja") return ja_components_clientbanner_cta1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_clientbanner_cta1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_clientbanner_cta1(inputs)
	return ko_components_clientbanner_cta1(inputs)
});
export { components_clientbanner_cta1 as "components.clientBanner.cta" }